import React from 'react'
import { Helmet } from 'react-helmet-async'

const TermsPage: React.FC = () => (
  <>
    <Helmet>
      <title>Terms of Service - AI Decision Maker | Free Online Decision Assistant</title>
      <meta name="description" content="Terms of Service for AI Decision Maker. Read our terms and conditions for using our free online decision assistant and AI decision maker tools." />
      <meta name="keywords" content="ai decision maker terms, decision assistant terms of service, terms and conditions, ai decision maker legal, service terms" />
      <meta property="og:title" content="Terms of Service - AI Decision Maker" />
      <meta property="og:description" content="Terms of Service for AI Decision Maker. Read our terms and conditions for using our free online decision assistant." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://aidecision.org/terms" />
      <meta name="twitter:title" content="Terms of Service - AI Decision Maker" />
      <meta name="twitter:description" content="Terms of Service for AI Decision Maker. Read our terms and conditions." />
      <link rel="canonical" href="https://aidecision.org/terms" />
      
      {/* Structured Data for Terms Page */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Terms of Service - AI Decision Maker",
          "description": "Terms of Service for AI Decision Maker - free online decision assistant",
          "url": "https://aidecision.org/terms",
          "mainEntity": {
            "@type": "Organization",
            "name": "AI Decision Maker",
            "url": "https://aidecision.org"
          }
        })}
      </script>
    </Helmet>

    <div className="max-w-3xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-6 text-gray-900">Terms of Service - AI Decision Maker</h1>
      <p className="mb-4 text-gray-700 text-lg">
        Please read these Terms of Service ("Terms") carefully before using AI Decision Maker, our free online decision assistant and AI decision maker tools.
      </p>
      <h2 className="text-xl font-semibold mt-8 mb-2">1. Acceptance of Terms</h2>
      <p className="mb-2 text-gray-700">By accessing or using this website, you agree to be bound by these Terms.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">2. Use of Service</h2>
      <p className="mb-2 text-gray-700">You may use AI Decision Maker for personal and non-commercial purposes only. Do not misuse the service or attempt to disrupt its functionality.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">3. Intellectual Property</h2>
      <p className="mb-2 text-gray-700">All content, trademarks, and code are the property of AI Decision Maker and its creators. Unauthorized use is prohibited.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">4. Disclaimer</h2>
      <p className="mb-2 text-gray-700">AI Decision Maker provides decision support tools and AI analysis for informational purposes only. We do not guarantee the accuracy or suitability of any result. Use at your own risk.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">5. Limitation of Liability</h2>
      <p className="mb-2 text-gray-700">We are not liable for any damages arising from the use or inability to use this service.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">6. Changes to Terms</h2>
      <p className="mb-2 text-gray-700">We may update these Terms at any time. Continued use of the service constitutes acceptance of the new Terms.</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">7. Contact</h2>
      <p className="mb-2 text-gray-700">For questions about these Terms, contact us at <a href="mailto:support@aidecision.org" className="text-blue-600 underline">support@aidecision.org</a>.</p>
      <p className="text-gray-500 text-sm mt-8">Effective date: July 2024</p>
    </div>
  </>
)

export default TermsPage 